let initialState = {
  isFilterPanelVisible: false,
  filterActiveKey: null,
  filterPanelData: [],
  filterDate: { fromDate: "", toDate: "" },
  filterApply: false,
  filterDateActiveKey: null,
  isFilterApplied: false,
  isWidgetEdit: false,
  bubbleRef: null,
  radioArray: {
    global_dashboard: { data: [] },
    dashboard_section: { data: [] },
    dashboard_widget: { data: [] },
    template_global: { data: [] },
    template_section: { data: [] },
    template_widget: { data: [] },
    graph_page: { data: [] },
    orm_dashboard: { data: [] },
    share_modal: { data: [] },
    widgetMaker: { data: [] },
    command_center_global: { data: [] },
    command_center_section: { data: [] },
    command_center_widget: { data: [] },
    y_series_1: { data: [] },
    y_series_2: { data: [] },
    y_series_3: { data: [] },
    y_series_4: { data: [] },
    y_series_5: { data: [] },
    kpi_card_1: { data: [] },
    deep_dive_global: { data: [] },
    filter_templates: { data: [] },
  },
  widgetsClearFilter: false,
  radioChecked: {
    global_dashboard: { data: {} },
    dashboard_section: { data: {} },
    dashboard_widget: { data: {} },
    template_global: { data: {} },
    template_section: { data: {} },
    template_widget: { data: {} },
    graph_page: { data: {} },
    orm_dashboard: { data: {} },
    share_modal: { data: {} },
    widgetMaker: { data: {} },
    command_center_global: { data: {} },
    command_center_section: { data: {} },
    command_center_widget: { data: {} },
    y_series_1: { data: {} },
    y_series_2: { data: {} },
    y_series_3: { data: {} },
    y_series_4: { data: {} },
    y_series_5: { data: {} },
    kpi_card_1: { data: {} },
    deep_dive_global: { data: [] },
    filter_templates: { data: [] },
  },
  checkedState: {},
  checkedStateArray: [],
  removeWidgetFlag: false,
  filterChange: false,
  filterTemplates: null,
  pinnedFilterTemplates: null,
};
const Filter = (state = initialState, action) => {
  switch (action.type) {
    case "SET_FILTER_PANEL_VISIBLE":
      return {
        ...state,
        isFilterPanelVisible: action.payload,
      };
    case "SET_FILTER_DATA":
      return {
        ...state,
        filterPanelData: action.payload,
      };
    case "SET_FILTER_ACTIVE_KEY":
      return {
        ...state,
        filterActiveKey: action.payload,
      };
    case "SET_FILTER_DATE":
      return {
        ...state,
        filterDate: action.payload,
      };
    case "SET_FILTER_APPLY":
      return {
        ...state,
        filterApply: action.payload,
      };
    case "SET_FILTER_DATE_ACTIVE_KEY":
      return {
        ...state,
        filterDateActiveKey: action.payload,
      };
    case "SET_FILTER_APPLIED":
      return {
        ...state,
        isFilterApplied: action.payload,
      };
    case "SET_RADIO_ARRAY":
      return {
        ...state,
        radioArray: action.payload,
      };

    case "SET_RADIO_CHECKED":
      return {
        ...state,
        radioChecked: action.payload,
      };
    case "SET_FILTER_CHANGE":
      return {
        ...state,
        filterChange: action.payload,
      };
    case "SET_CHECKED":
      return {
        ...state,
        checkedState: action.payload,
      };
    case "SET_CHECKED_ARRAY":
      return {
        ...state,
        checkedStateArray: action.payload,
      };
    case "IS_WIDGET_EDIT":
      return {
        ...state,
        isWidgetEdit: action.payload,
      };
    case "SET_REMOVE_WORDS_PANEL_FLAG":
      return {
        ...state,
        removeWidgetFlag: action.payload,
      };
    case "SET_WIDGET_CLEAR_FILTER":
      return {
        ...state,
        widgetsClearFilter: action.payload,
      };
    case "SET_BUBBLECHART_REF":
      return {
        ...state,
        bubbleRef: action.payload,
      };
    case "SET_FILTER_TEMPLATE":
      return {
        ...state,
        filterTemplates: action.payload,
      };
    case "SET_PINNED_FILTER_TEMPLATE":
      return {
        ...state,
        pinnedFilterTemplates: action.payload,
      };
    default:
      return state;
  }
};

export default Filter;
